import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppModule } from './app.module';
import {AuthService} from "./services/auth.service";

@Injectable({
  providedIn: 'root'
})
export class AppGuard implements CanActivate {
	constructor(
    private authService: AuthService,
    private router: Router) {
  }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.authService.isAuthenticated())
        return true;
      return this.router.parseUrl("/home");
  }
  
}
